var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.946,
    height: 35.144,
    viewBox: "0 0 82.946 35.144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#9b0405;stroke:#fff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_638546",
    "data-name": 638546,
    transform: "translate(.5 -148.833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_807",
    "data-name": "Group 807",
    transform: "translate(0 149.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_806",
    "data-name": "Group 806"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    d: "M81.726 173.892L76.074 154.4a6.837 6.837 0 0 0-6.6-5.068H11.95a1.707 1.707 0 0 0-1.33.639c-.065.081-9.92 18.118-9.92 18.118a5.792 5.792 0 0 0 5.085 8.559h10.1l.329 1.48a6.789 6.789 0 0 0 6.665 5.348h.057l52.767-1.706a6.236 6.236 0 0 0 6.015-7.878zm-75.937-.658a2.376 2.376 0 0 1-2.374-2.374 2.407 2.407 0 0 1 .287-1.137l7.569-13.874 3.864 17.385zm69.865 5.123l-52.79 1.706a3.391 3.391 0 0 1-3.308-2.674l-5.479-24.641h55.4a3.429 3.429 0 0 1 3.308 2.569l5.655 19.5a2.687 2.687 0 0 1 .093.719 2.84 2.84 0 0 1-2.879 2.821z",
    className: "cls-1",
    "data-name": "Path 1000",
    transform: "translate(0 -149.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    d: "M207.524 225.982l-33.854 1.059a1.707 1.707 0 0 0 .053 3.413h.053l33.854-1.06a1.705 1.705 0 0 0 1.654-1.759 1.653 1.653 0 0 0-1.76-1.653z",
    className: "cls-1",
    "data-name": "Path 1001",
    transform: "translate(-144.484 -213.708)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    d: "M228.932 270.323l-23.761.74a1.708 1.708 0 0 0 .053 3.414h.053l23.761-.74a1.708 1.708 0 0 0 1.654-1.761 1.673 1.673 0 0 0-1.76-1.653z",
    className: "cls-1",
    "data-name": "Path 1002",
    transform: "translate(-170.944 -250.955)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLab);
export default __webpack_public_path__ + "static/media/lab.6e89846dc3ef5afbe35b95903678aa44.svg";
export { ForwardRef as ReactComponent };